import { useEffect, useState } from 'react';

/**
 * Hook to redirect to login page if email is missing
 * @param email The email to check
 * @param loginPath The login path to redirect to
 */
export function useRedirectIfEmailMissing(
  email: string | null,
  loginPath: string = '/login'
) {
  const [isClientSide, setIsClientSide] = useState(false);
  useEffect(() => setIsClientSide(true), []);

  useEffect(() => {
    if (!email && isClientSide) {
      window.location.href = loginPath;
    }
  }, [email, loginPath, isClientSide]);
}
